<template lang="pug">
div
  v-divider
  .pa-4.d-flex(@click="show_checklist = !show_checklist")
    h6.text-h6.mr-auto Чеклист
    v-btn.rounded(text small icon)
      v-icon mdi-chevron-down
  v-expand-transition
    div(v-if="show_checklist")
      v-divider
      .pa-2
        .d-flex.align-center
          v-text-field.dense-input(
            v-model="name"
            filled
            dense
            label="Новый пункт"
            @keyup.enter="createTodo"
            hide-details
          )
            template(#append)
              v-btn.rounded(@click="createTodo" :disabled="!name" color="success" height="52px" width="52px" fab tile small)
                v-icon mdi-plus
        div(v-for="todo in todos").d-flex.mt-2
          v-checkbox.ma-0(
            v-model="todo.is_finish"
            @change="updateTodo({ id: todo.id, is_finish: $event })"
            hide-details
          )
          p.mb-0.mt-1.mr-auto {{ todo.name }}

          v-btn.rounded.align-self-start(@click="deleteTodo(todo.id)" color="error" fab tile x-small)
            v-icon mdi-close
</template>

<script>
import todoListService, { CRUDTodoLists } from '@/services/API/todo-list';

export default {
  props:{
    questionId: { type:Number, required: true },
  },
  data() {
    return {
      name:'',

      todos: [],
      show_checklist:false,
    };
  },

  created() {
    this.fetchTodos();
  },
  methods:{
    async fetchTodos() {
      const params = { 'search[client_question_id]': this.questionId, 'sort':'id' };
      const response = await CRUDTodoLists.getAll(params);
      this.todos = response.data.data;
    },

    async createTodo() {
      if (!this.name) return;

      const params = {
        client_question_id: this.questionId,
        name:this.name,
      };
      const response = await CRUDTodoLists.create(params);
      this.todos.push(response.data.data);
      this.name = '';
    },

    async deleteTodo(todoId) {
      await CRUDTodoLists.delete(todoId);
      this.todos = this.todos.filter(({ id }) => id !== todoId);
    },

    async updateTodo({ id, is_finish }) {
      await todoListService.changeStatus(id);
      const index = this.todos.findIndex(({ id:todoId }) => todoId === id);
      const todos = [...this.todos];
      todos[index].is_finish = is_finish;
      this.todos  = todos;
    },

  },

};
</script>

<style lang="scss">
.v-input.dense-input {
  .v-input__control {
    .v-input__slot {
      padding-right: 0 !important;
    }
    .v-input__append-inner{
      margin-top: 0 !important;
    }
  }
}
</style>
